var _rect, _rect2, _rect3, _g, _rect4, _g2, _rect5, _g3, _rect6, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_125)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4261 61V58.4545L77.3011 50.2955C78.142 49.4091 78.8352 48.6326 79.3807 47.9659C79.9337 47.2917 80.3466 46.6515 80.6193 46.0455C80.892 45.4394 81.0284 44.7955 81.0284 44.1136C81.0284 43.3409 80.8466 42.6742 80.483 42.1136C80.1193 41.5455 79.6231 41.1098 78.9943 40.8068C78.3655 40.4962 77.6572 40.3409 76.8693 40.3409C76.036 40.3409 75.3087 40.5114 74.6875 40.8523C74.0663 41.1932 73.589 41.6742 73.2557 42.2955C72.9223 42.9167 72.7557 43.6439 72.7557 44.4773H69.4034C69.4034 43.0606 69.7292 41.822 70.3807 40.7614C71.0322 39.7008 71.9261 38.8788 73.0625 38.2955C74.1989 37.7045 75.4905 37.4091 76.9375 37.4091C78.3996 37.4091 79.6875 37.7008 80.8011 38.2841C81.9223 38.8598 82.7973 39.6477 83.4261 40.6477C84.0549 41.6402 84.3693 42.7614 84.3693 44.0114C84.3693 44.875 84.2064 45.7197 83.8807 46.5455C83.5625 47.3712 83.0057 48.2917 82.2102 49.3068C81.4148 50.3144 80.3087 51.5379 78.892 52.9773L74.267 57.8182V57.9886H84.7443V61H69.4261Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_125)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 16,
    width: 39,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.528 61.3182C116.968 61.3182 115.574 61.0492 114.347 60.5114C113.127 59.9735 112.161 59.2273 111.449 58.2727C110.744 57.3106 110.366 56.197 110.312 54.9318H113.881C113.926 55.6212 114.157 56.2197 114.574 56.7273C114.998 57.2273 115.551 57.6136 116.233 57.8864C116.915 58.1591 117.672 58.2955 118.506 58.2955C119.422 58.2955 120.233 58.1364 120.938 57.8182C121.65 57.5 122.206 57.0568 122.608 56.4886C123.009 55.9129 123.21 55.25 123.21 54.5C123.21 53.7197 123.009 53.0341 122.608 52.4432C122.214 51.8447 121.634 51.375 120.869 51.0341C120.112 50.6932 119.195 50.5227 118.119 50.5227H116.153V47.6591H118.119C118.983 47.6591 119.741 47.5038 120.392 47.1932C121.051 46.8826 121.566 46.4508 121.938 45.8977C122.309 45.3371 122.494 44.6818 122.494 43.9318C122.494 43.2121 122.331 42.5871 122.006 42.0568C121.688 41.5189 121.233 41.0985 120.642 40.7955C120.059 40.4924 119.369 40.3409 118.574 40.3409C117.816 40.3409 117.108 40.4811 116.449 40.7614C115.797 41.0341 115.267 41.428 114.858 41.9432C114.449 42.4508 114.229 43.0606 114.199 43.7727H110.801C110.839 42.5152 111.21 41.4091 111.915 40.4545C112.627 39.5 113.566 38.7538 114.733 38.2159C115.9 37.678 117.195 37.4091 118.619 37.4091C120.112 37.4091 121.4 37.7008 122.483 38.2841C123.574 38.8598 124.415 39.6288 125.006 40.5909C125.604 41.553 125.9 42.6061 125.892 43.75C125.9 45.053 125.536 46.1591 124.801 47.0682C124.074 47.9773 123.104 48.5871 121.892 48.8977V49.0795C123.438 49.3144 124.634 49.928 125.483 50.9205C126.339 51.9129 126.763 53.1439 126.756 54.6136C126.763 55.8939 126.407 57.0417 125.688 58.0568C124.975 59.072 124.002 59.8712 122.767 60.4545C121.532 61.0303 120.119 61.3182 118.528 61.3182Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 16,
    width: 39,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_75_125)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.281 56.4545V53.6136L162.338 37.7273H164.577V41.9091H163.156L155.963 53.2955V53.4773H169.747V56.4545H152.281ZM163.315 61V55.5909L163.338 54.2955V37.7273H166.668V61H163.315Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5057 37.7273V61H34.983V41.25H34.8466L29.2784 44.8864V41.5227L35.0852 37.7273H38.5057Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_125"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_125"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 16,
    width: 39,
    height: 66,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_75_125"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 16,
    width: 38,
    height: 66,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateFour);
export default __webpack_public_path__ + "static/media/template_four.134759fa1902b7a0c3384f836aed9ee4.svg";
export { ForwardRef as ReactComponent };